export const customerSignoffMessagingSelector = (state) => ({
  advancesById: state.entities.advances.byId,
  country: state.country.country,
  portalRedesignEnabled: state.config.portalRedesignEnabled,
});
